import { RawSocket, type Socket } from './raw-socket';

const SOCKET_URL =
  import.meta.env.VITE_SOCKET_URL || import.meta.env.VITE_WS_URL || 'http://localhost:8000';

class SocketManager {
  private socket: RawSocket | null = null;

  connect(token: string): RawSocket {
    // Reuse an existing socket whether it's connecting or connected — only
    // create fresh if there's none. Without this, both setAuth and
    // onRehydrateStorage racing during page load would create two sockets
    // and hooks that captured one would emit into the other (dead) ref.
    if (this.socket) {
      return this.socket;
    }

    const sock = new RawSocket({
      url: SOCKET_URL,
      auth: () => ({ token: localStorage.getItem('auth_token') || token }),
      reconnectionDelay: 1000,
      reconnectionDelayMax: 10000,
    });
    sock.connect();
    this.socket = sock;
    return sock;
  }

  disconnect(): void {
    this.socket?.disconnect();
    this.socket = null;
  }

  getSocket(): RawSocket | null {
    return this.socket;
  }

  isConnected(): boolean {
    return this.socket?.connected || false;
  }
}

export const socketManager = new SocketManager();
export type { Socket };
